export const EMENDA = 'EMENDA';
export const EMENDA_START = 'EMENDA_START';
export const EMENDA_SUCCESS = 'EMENDA_SUCCESS';
export const EMENDA_ERROR = 'EMENDA_ERROR';

export const CONSULTA_EMENDAS_MUNICIPAIS = 'CONSULTA_EMENDAS_MUNICIPAIS';
export const CONSULTA_EMENDAS_MUNICIPAIS_START =
  'CONSULTA_EMENDAS_MUNICIPAIS_START';
export const CONSULTA_EMENDAS_MUNICIPAIS_SUCCESS =
  'CONSULTA_EMENDAS_MUNICIPAIS_SUCCESS';
export const CONSULTA_EMENDAS_MUNICIPAIS_ERROR =
  'CONSULTA_EMENDAS_MUNICIPAIS_ERROR';

export const CONSULTA_EMENDAS_MUNICIPAIS_TOTAL =
  'CONSULTA_EMENDAS_MUNICIPAIS_TOTAL';
export const CONSULTA_EMENDAS_MUNICIPAIS_TOTAL_START =
  'CONSULTA_EMENDAS_MUNICIPAIS_TOTAL_START';
export const CONSULTA_EMENDAS_MUNICIPAIS_TOTAL_SUCCESS =
  'CONSULTA_EMENDAS_MUNICIPAIS_TOTAL_SUCCESS';
export const CONSULTA_EMENDAS_MUNICIPAIS_TOTAL_ERROR =
  'CONSULTA_EMENDAS_MUNICIPAIS_TOTAL_ERROR';

export const CONSULTA_EMENDAS_FEDERAIS = 'CONSULTA_EMENDAS_FEDERAIS';
export const CONSULTA_EMENDAS_FEDERAIS_START =
  'CONSULTA_EMENDAS_FEDERAIS_START';
export const CONSULTA_EMENDAS_FEDERAIS_SUCCESS =
  'CONSULTA_EMENDAS_FEDERAIS_SUCCESS';
export const CONSULTA_EMENDAS_FEDERAIS_ERROR =
  'CONSULTA_EMENDAS_FEDERAIS_ERROR';

export const CONSULTA_EMENDAS_FEDERAIS_TOTAL =
  'CONSULTA_EMENDAS_FEDERAIS_TOTAL';
export const CONSULTA_EMENDAS_FEDERAIS_TOTAL_START =
  'CONSULTA_EMENDAS_FEDERAIS_TOTAL_START';
export const CONSULTA_EMENDAS_FEDERAIS_TOTAL_SUCCESS =
  'CONSULTA_EMENDAS_FEDERAIS_TOTAL_SUCCESS';
export const CONSULTA_EMENDAS_FEDERAIS_TOTAL_ERROR =
  'CONSULTA_EMENDAS_FEDERAIS_TOTAL_ERROR';

export const CONSULTA_EMENDAS_ESTADUAIS = 'CONSULTA_EMENDAS_ESTADUAIS';
export const CONSULTA_EMENDAS_ESTADUAIS_START =
  'CONSULTA_EMENDAS_ESTADUAIS_START';
export const CONSULTA_EMENDAS_ESTADUAIS_SUCCESS =
  'CONSULTA_EMENDAS_ESTADUAIS_SUCCESS';
export const CONSULTA_EMENDAS_ESTADUAIS_ERROR =
  'CONSULTA_EMENDAS_ESTADUAIS_ERROR';

export const CONSULTA_EMENDAS_ESTADUAIS_TOTAL =
  'CONSULTA_EMENDAS_ESTADUAIS_TOTAL';
export const CONSULTA_EMENDAS_ESTADUAIS_TOTAL_START =
  'CONSULTA_EMENDAS_ESTADUAIS_TOTAL_START';
export const CONSULTA_EMENDAS_ESTADUAIS_TOTAL_SUCCESS =
  'CONSULTA_EMENDAS_ESTADUAIS_TOTAL_SUCCESS';
export const CONSULTA_EMENDAS_ESTADUAIS_TOTAL_ERROR =
  'CONSULTA_EMENDAS_ESTADUAIS_TOTAL_ERROR';

export const EMENDA_MOVIMENTACAO = 'EMENDA_MOVIMENTACAO';
export const EMENDA_MOVIMENTACAO_START = 'EMENDA_MOVIMENTACAO_START';
export const EMENDA_MOVIMENTACAO_SUCCESS = 'EMENDA_MOVIMENTACAO_SUCCESS';
export const EMENDA_MOVIMENTACAO_ERROR = 'EMENDA_MOVIMENTACAO_ERROR';

export const RESET_CONSULTA_EMENDAS = 'RESET_CONSULTA_EMENDAS';

export const TIPO_TRANSFERENCIA = 'TIPO_TRANSFERENCIA';
export const TIPO_TRANSFERENCIA_START = 'TIPO_TRANSFERENCIA_START';
export const TIPO_TRANSFERENCIA_SUCCESS = 'TIPO_TRANSFERENCIA_SUCCESS';
export const TIPO_TRANSFERENCIA_ERROR = 'TIPO_TRANSFERENCIA_ERROR';

export const TIPO_ORIGEM = 'TIPO_ORIGEM';
export const TIPO_ORIGEM_START = 'TIPO_ORIGEM_START';
export const TIPO_ORIGEM_SUCCESS = 'TIPO_ORIGEM_SUCCESS';
export const TIPO_ORIGEM_ERROR = 'TIPO_ORIGEM_ERROR';

export const EMENDA_ENTIDADES_BENEFICIADAS = 'EMENDA_ENTIDADES_BENEFICIADAS';
export const EMENDA_ENTIDADES_BENEFICIADAS_START =
  'EMENDA_ENTIDADES_BENEFICIADAS_START';
export const EMENDA_ENTIDADES_BENEFICIADAS_SUCCESS =
  'EMENDA_ENTIDADES_BENEFICIADAS_SUCCESS';
export const EMENDA_ENTIDADES_BENEFICIADAS_ERROR =
  'EMENDA_ENTIDADES_BENEFICIADAS_ERROR';

export const EMENDA_LOCALIDADES_BENEFICIADAS =
  'EMENDA_LOCALIDADES_BENEFICIADAS';
export const EMENDA_LOCALIDADES_BENEFICIADAS_START =
  'EMENDA_LOCALIDADES_BENEFICIADAS_START';
export const EMENDA_LOCALIDADES_BENEFICIADAS_SUCCESS =
  'EMENDA_LOCALIDADES_BENEFICIADAS_SUCCESS';
export const EMENDA_LOCALIDADES_BENEFICIADAS_ERROR =
  'EMENDA_LOCALIDADES_BENEFICIADAS_ERROR';
